var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("entity-list", {
    attrs: {
      entity: "systemPage",
      "api-name": "systemPages",
      "filter-all": true,
      "entity-archive-headers": _vm.archiveHeaders
    },
    scopedSlots: _vm._u(
      [
        {
          key: `currentList`,
          fn: function({ entities, searchTerm, readRoute }) {
            return [
              _c("v-data-table", {
                staticClass: "elevation-1",
                attrs: {
                  headers: _vm.headers,
                  items: entities,
                  "items-per-page": 15,
                  dense: "",
                  search: searchTerm,
                  "footer-props": {
                    showFirstLastPage: true,
                    itemsPerPageOptions: [-1, 10, 15, 20, 25],
                    firstIcon: "mdi-arrow-collapse-left",
                    lastIcon: "mdi-arrow-collapse-right",
                    prevIcon: "mdi-minus",
                    nextIcon: "mdi-plus"
                  }
                },
                scopedSlots: _vm._u(
                  [
                    {
                      key: `item.name`,
                      fn: function({ item }) {
                        return [
                          _c(
                            "router-link",
                            {
                              attrs: {
                                to: {
                                  name: readRoute,
                                  params: { id: item.keyId }
                                },
                                title: item.name
                              }
                            },
                            [_vm._v(" " + _vm._s(item.name) + " ")]
                          )
                        ]
                      }
                    }
                  ],
                  null,
                  true
                )
              })
            ]
          }
        },
        {
          key: `archiveList`,
          fn: function({ entities, searchTerm, readRoute }) {
            return [
              _c("v-data-table", {
                staticClass: "elevation-1",
                attrs: {
                  headers: _vm.archiveHeaders,
                  items: entities,
                  "items-per-page": 15,
                  dense: "",
                  search: searchTerm,
                  "footer-props": {
                    showFirstLastPage: true,
                    itemsPerPageOptions: [-1, 10, 15, 20, 25],
                    firstIcon: "mdi-arrow-collapse-left",
                    lastIcon: "mdi-arrow-collapse-right",
                    prevIcon: "mdi-minus",
                    nextIcon: "mdi-plus"
                  }
                },
                scopedSlots: _vm._u(
                  [
                    {
                      key: `item.reference`,
                      fn: function({ item }) {
                        return [
                          _c(
                            "router-link",
                            {
                              attrs: {
                                to: {
                                  name: readRoute,
                                  params: { id: item.keyId }
                                },
                                title: item.reference
                              }
                            },
                            [_vm._v(" " + _vm._s(item.reference) + " ")]
                          )
                        ]
                      }
                    },
                    {
                      key: `item.archiveDate`,
                      fn: function({ item }) {
                        return [
                          _vm._v(
                            " " +
                              _vm._s(
                                _vm._f("luxonSortableDateTime")(
                                  item.archiveDate
                                )
                              ) +
                              " "
                          )
                        ]
                      }
                    }
                  ],
                  null,
                  true
                )
              })
            ]
          }
        }
      ],
      null,
      true
    )
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }